<template>
    <section>
      <div class="">
        <footer class="footer is-background-light">
          <div class="content has-text-centered">
            <p>
              <strong>NEON/NOE</strong> by Christoph Noe
              <b-icon icon="map-marker"></b-icon> Pilgersheimer Str. 32, 81543 München, Germany
              | <strong>+49 177 6547900</strong> | <router-link to="/imprint">Imprint</router-link>.
            </p>
          </div>
        </footer>
      </div>
    </section>
</template>


<script>
export default {
  name: 'Footer',
  props: {
  },
};
</script>
